<template>
  <validation-provider
    rules="required"
    :name="'select-product'"
    v-slot="{ errors }"
    tag="div">
    <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
      <v-select
        class="w-100"
        :options="products"
        v-model="product_id"
        :filterBy="filterByForProducts"
        :reduce="product => product.id"
        :placeholder="$t('product.selectProduct')"
        label="code">
        <template slot="no-options">
          {{ $t('product.noProductsMatchingGivenPhrase') }}&hellip;
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center w-100 normal-white-space">
            {{ option.code }} - {{ option.name }}
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center w-100 normal-white-space">
            {{ option.code }} - {{ option.name }}
          </div>
        </template>
      </v-select>
    </div>
  </validation-provider>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-product',
  props: [
    'productID',
    'returnProductNameAndCode'
  ],
  data () {
    return {
      product_id: 0,
      products: [],
      loadProductsError: false
    };
  },
  watch: {
    product_id (newValue) {
      if (this.returnProductNameAndCode) {
        let foundedProduct = this.products.filter(product => product.id === newValue);
        let productName = '';
        let productCode = '';

        if (foundedProduct[0]) {
          productName = foundedProduct[0].name;
          productCode = foundedProduct[0].code;
        }

        this.$bus.$emit('ui-select-product-updated', {
          productID: newValue,
          productName,
          productCode
        });
      } else {
        this.$bus.$emit('ui-select-product-updated', newValue);
      }
    }
  },
  mounted () {
    this.product_id = this.productID;
    this.fetchProducts();
  },
  methods: {
    filterByForProducts (option, label, search) {
      return (option.code + option.name).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    fetchProducts () {
      let endpointUrl = '/customer-panel/products/all-items';

      FormUtils.loadAdditionalData(this, {
        endpoint: endpointUrl,
        outputKey: 'products',
        errorKey: 'loadProductsError'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.is-v-select-wrapper > div {
  width: 100%;
}
</style>
